import qs from 'query-string';

import { getAppUrl } from '../../urls';
import {
  routes,
  PATH_TYPE_MAP,
  LANDING_PAGE,
  FLYER_PAGE,
  VDP_PAGE,
  CARD_PAGE,
  LEGAL_PAGE,
  ERROR_PAGE,
} from '../../../routes';

const URL_BASE = getAppUrl();

export function flyerResetButtonURL({ isUPLP, path, query }) {
  if (isUPLP) {
    return `${path}?tab=flyers&page=1`;
  } else {
    const { category } = query;
    return category ? `${path}?category=${category}` : path;
  }
}

export function buildURLFromQueryInfo(pathname, query) {
  const pathType = PATH_TYPE_MAP[pathname];
  let url = '';
  let queryStringParams = { ...query };
  switch (pathType) {
    case LANDING_PAGE:
    case LEGAL_PAGE:
    case ERROR_PAGE:
    case FLYER_PAGE:
      url = pathname;
      break;
    case CARD_PAGE:
      url = `/cards${pathname}/${query.slug}`;
      if (pathname === '/cards') {
        url = `/cards`;
      }
      delete queryStringParams['slug'];
      break;
    case VDP_PAGE:
      url = `/flyer/vibes/${query.slug}`;
      delete queryStringParams['slug'];
      break;
  }

  url = `${url}?${qs.stringify(queryStringParams)}`;

  return url;
}

export function generateQueryString(queryObject) {
  return Object.keys(queryObject).reduce((accum, key) => {
    if (typeof queryObject[key] !== 'undefined') {
      accum += accum.length === 0 ? '?' : '&';
      accum += `${key}=${queryObject[key]}`;
    }
    return accum;
  }, '');
}

export function toggleQueryParameter(
  toggleValue,
  currentQueryValue,
  singleValueSelection = false,
) {
  if (singleValueSelection) {
    return toggleValue;
  }

  if (toggleValue.indexOf(',') > -1) {
    currentQueryValue =
      typeof currentQueryValue === 'undefined' ? [] : currentQueryValue;
    const toggleArray = toggleValue.split(',');

    const hasAllValues = toggleArray.reduce(
      (accum, element) =>
        accum ? currentQueryValue.indexOf(element) > -1 : false,
      true,
    );

    const arrayResult = toggleArray.reduce((accum, element) => {
      if (hasAllValues || accum.indexOf(element) < 0) {
        accum = toggleQueryParameter(element, accum);
      }
      return accum;
    }, currentQueryValue);

    return arrayResult.length > 0 ? arrayResult : undefined;
  }

  let queryValue;
  let toggleValueIndex = currentQueryValue
    ? currentQueryValue.indexOf(toggleValue)
    : -1;

  switch (typeof currentQueryValue) {
    // I'ts an array if more than one selection is active count as objects...
    case 'object':
      queryValue = [...currentQueryValue];
      if (toggleValueIndex < 0) {
        queryValue.push(toggleValue);
      } else {
        queryValue.splice(toggleValueIndex, 1);
      }
      break;
    // It's a tring if only one selection is active...
    case 'string':
      if (toggleValueIndex < 0) {
        queryValue = [currentQueryValue, toggleValue];
      } else {
        queryValue = undefined;
      }
      break;
    // It's undefined if nothing is in the URL.  We'll also use this for the fail case...
    default:
      queryValue = toggleValue;
      break;
  }

  return queryValue;
}

export function removeQueryAndHash(url) {
  return url.split('#')[0].split('?')[0];
}

export function buildBaseUrl(url) {
  return URL_BASE + removeQueryAndHash(url);
}

export function buildCardsUrl(nodePath, query) {
  const urlParts = ['/cards'];
  if (nodePath) {
    urlParts.push(`/${nodePath}`);
  }
  if (query) {
    urlParts.push(`?q=${query}`);
  }

  return urlParts.join('');
}

export function buildCustomizeUrl(id) {
  return `/events/new?package_id=${id}`;
}

export function buildDeliveryUrl(eventId) {
  return `/events/${eventId}/delivery`;
}

export function buildDesignUrl(eventId) {
  return `/events/${eventId}/design`;
}

export function buildCardPreviewUrl(cardId) {
  return `${URL_BASE}/cards/card/${cardId}/preview`;
}

export function buildEventPreviewUrl(eventId) {
  return `/events/${eventId}/event_page?preview=true`;
}

export function buildSendUrl(eventId) {
  return `/events/${eventId}/send`;
}

export function buildSentUrl(eventId) {
  return `/events/${eventId}/sent`;
}

export function buildTrackingUrl(eventId) {
  return `/events/${eventId}/tracking?skip_ios_takeover=true`;
}
